export const FormatsData: {[k: string]: SpeciesFormatsData} = {
	alakazammega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "shadowball", "focusblast", "recover"],
	},
	arceus: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusbug: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusdragon: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusdark: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceuselectric: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusfairy: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusfire: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusfighting: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusflying: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusground: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusgrass: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusghost: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusice: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceuspsychic: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceusrock: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceuspoison: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceuswater: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceussteel: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	blastoisemega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	blazikenmega: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["overheat", "closecombat", "uturn", "protect"],
	},
	calyrexice: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	calyrexshadow: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	cinderace: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["pyroball", "suckerpunch", "uturn", "highjumpkick"],
	},
	darkrai: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["hypnosis", "moonlitwaltz", "focusblast", "nastyplot"],
	},
	darmanitangalar: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["icepunch", "flareblitz", "uturn", "earthquake"],
	},
	deoxysattack: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	deoxys: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	deoxysspeed: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	dialga: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "flashcannon", "fireblast", "stealthrock"],
	},
	dracovish: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["fishiousrend", "crunch", "psychicfangs", "earthquake"],
	},
	dragapult: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "shadowball", "uturn", "flamethrower"],
	},
	eternatus: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesect: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	gengarmega: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["hex", "trashtalk", "substitute", "toxic"],
	},
	giratina: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["defog", "curse", "willowisp", "rest"],
	},
	giratinaorigin: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["poltergeist", "shadowsneak", "dracometeor", "earthquake"],
	},
	groudon: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["precipiceblades", "heatcrash", "swordsdance", "aridabsorption"],
	},
	hooh: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	kangaskhanmega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["fakeout", "suckerpunch", "doubleedge", "poweruppunch"],
	},
	kyogre: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["waterspout", "thunder", "icebeam", "originpulse"],
	},
	kyuremblack: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "iciclespear", "fusionbolt", "fling"],
	},
	kyuremwhite: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["icebeam", "freezedry", "earthpower", "fusionflare"],
	},
	landorus: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	lucariomega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "closecombat", "meteormash", "skyuppercut"],
	},
	lugia: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	lunala: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	magearna: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["fleurcannon", "voltswitch", "icebeam", "focusblast"],
	},
	marshadow: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	metagrossmega: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["meteormash", "thunderpunch", "icepunch", "earthquake"],
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	naganadel: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["rapidspin", "dracometeor", "sludgewave", "flamethrower"],
	},
	mewtwomegax: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	mewtwomegay: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	necrozmadawnwings: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	necrozmaduskmane: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	necrozmaultra: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	palkia: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "spacialrend", "thunder", "fireblast"],
	},
	pheromosa: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["bugbuzz", "focusblast", "icebeam", "shockwave"],
	},
	rayquaza: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["hurricane", "focusblast", "icebeam", "thunderbolt"],
	},
	rayquazamega: {
		tier: "AG",
		doublesTier: "DOU",
		randomBattleMoves: ["dragonascent", "vcreate", "extremespeed", "swordsdance"],
	},
	reshiram: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	salamencemega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	shayminsky: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["seedflare", "skysoiree", "earthpower", "healingwish"],
	},
	solgaleo: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	spectrier: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["substitute", "curse", "shadowball", "calmmind"],
	},
	tornadustherian: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["hurricane", "focusblast", "heatwave", "nastyplot", "uturn"],
	},
	urshifu: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["wickedblow", "closecombat", "uturn", "icepunch"],
	},
	xerneas: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["geomancy", "focusblast", "moonblast", "lifedew"],
	},
	yveltal: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "oblivionwing", "taunt", "defog"],
	},
	zacian: {
		tier: "AG",
		doublesTier: "DOU",
		randomBattleMoves: ["playrough", "closecombat", "lightninglance", "swordsdance"],
	},
	zaciancrowned: {
		tier: "AG",
		doublesTier: "DOU",
		randomBattleMoves: ["playrough", "closecombat", "lightninglance", "behemothblade"],
	},
	zamazenta: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["crunch", "closecombat", "howl", "wildcharge"],
	},
	zamazentacrowned: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["reconstruct", "closecombat", "crunch", "behemothbash"],
	},
	zekrom: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zygarde: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zygardecomplete: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectburn: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectshock: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectchill: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectdouse: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	groudonprimal: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["precipiceblades", "heatcrash", "stealthrock", "aridabsorption"],
	},
	kyogreprimal: {
		tier: "Uber",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "thunder", "icebeam", "originpulse"],
	},
	darmanitangalarzen: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["icepunch", "flareblitz", "uturn", "earthquake"],
	},
	darmanitanzen: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["fireblast", "expandingforce", "uturn", "focusblast"],
	},
	meloettapirouette: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["return", "closecombat", "knockoff", "rapidspin"],
	},
	blissey: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["lifedew", "teleport", "stealthrock", "counterspell"],
	},
	chansey: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["softboiled", "teleport", "toxic", "seismictoss"],
	},
	charizardmegax: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "flareblitz", "dragonclaw", "thunderpunch"],
	},
	charizardmegay: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["weatherball", "focusblast", "solarbeam", "roost"],
	},
	clefable: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["moonblast", "lifedew", "stealthrock", "flamethrower"],
	},
	corviknight: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["uturn", "bravebird", "defog", "roost"],
	},
	excadrill: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "earthquake", "ironhead", "aridabsorption"],
	},
	ferrothorn: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "powerwhip", "knockoff", "leechseed"],
	},
	garchompmega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "earthquake", "scaleshot", "firefang"],
	},
	garchomp: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "dracometeor", "fireblast", "aridabsorption"],
	},
	gliscor: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["uturn", "earthquake", "knockoff", "roost"],
	},
	greninja: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "hydropump", "icebeam", "uturn"],
	},
	greninjaash: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "darkpulse", "watershuriken", "spikes"],
	},
	heatran: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "earthpower", "magmastorm", "flashcannon"],
	},
	kartana: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "leafblade", "knockoff", "sacredsword"],
	},
	kommoo: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["clangoroussoul", "clangingscales", "focusblast", "boomburst"],
	},
	kyurem: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["icebeam", "freezedry", "roost", "earthpower"],
	},
	landorustherian: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "uturn", "stoneedge", "stealthrock"],
	},
	lopunnymega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["fakeout", "return", "closecombat", "uturn"],
	},
	magnezone: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "hiddenpowerfire", "flashcannon", "voltswitch"],
	},
	mawilemega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["enchantedpunch", "icepunch", "thunderpunch", "firefang"],
	},
	pelipper: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "roost", "defog", "uturn"],
	},
	rillaboom: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["grassyglide", "woodhammer", "knockoff", "uturn"],
	},
	scizormega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["bulkup", "bulletpunch", "knockoff", "roost"],
	},
	serperior: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["leafstorm", "hiddenpowerfire", "substitute", "glare"],
	},
	slowbro: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "futuresight", "slackoff", "teleport"],
	},
	swampertmega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["liquidation", "flipturn", "earthquake", "acidicfists"],
	},
	tapufini: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["defog", "scald", "moonblast", "taunt"],
	},
	tapukoko: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["wildcharge", "enchantedpunch", "bravebird", "uturn"],
	},
	tapulele: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["psyshock", "psychic", "focusblast", "moonblast"],
	},
	toxapex: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["toxic", "recover", "scald", "haze"],
	},
	tyranitar: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "stoneedge", "crunch", "pursuit"],
	},
	tyranitarmega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "stoneedge", "crunch", "icepunch"],
	},
	victini: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["vcreate", "boltstrike", "glaciate", "uturn"],
	},
	volcarona: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["bugbuzz", "fierydance", "psychic", "quiverdance"],
	},
	weavile: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "tripleaxel", "iceshard", "swordsdance"],
	},
	zapdos: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "hurricane", "heatwave", "uturn"],
	},
	silvally: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "explosion", "earthquake", "uturn"],
	},
	silvallybug: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "blazekick", "earthquake", "uturn"],
	},
	silvallydragon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "trashtalk", "flamethrower", "partingshot"],
	},
	silvallydark: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "pursuit", "ironhead", "uturn"],
	},
	silvallyelectric: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "icebeam", "flamethrower", "uturn"],
	},
	silvallyfairy: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "defog", "toxic", "uturn"],
	},
	silvallyfire: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "flamecharge", "earthquake", "swordsdance"],
	},
	silvallyfighting: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "aggravate", "earthquake", "swordsdance"],
	},
	silvallyflying: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "crushclaw", "earthquake", "defog"],
	},
	silvallyground: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "flamecharge", "rockslide", "swordsdance"],
	},
	silvallygrass: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "blazekick", "earthquake", "partingshot"],
	},
	silvallyghost: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "superpower", "earthquake", "uturn"],
	},
	silvallyice: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["icebeam", "flamethrower", "thunderbolt", "partingshot"],
	},
	silvallypsychic: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "blazekick", "earthquake", "explosion"],
	},
	silvallyrock: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "superpower", "earthquake", "swordsdance"],
	},
	silvallypoison: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["poisonfang", "defog", "earthquake", "partingshot"],
	},
	silvallywater: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["surf", "defog", "thunderbolt", "partingshot"],
	},
	silvallysteel: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["multiattack", "defog", "earthquake", "uturn"],
	},
	aerodactylmega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["dualwingbeat", "stoneedge", "earthquake", "roost"],
	},
	alakazam: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "focusblast", "dazzlinggleam", "calmmind"],
	},
	blacephalon: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["shadowball", "overheat", "flamethrower", "electroball"],
	},
	blaziken: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["flareblitz", "closecombat", "thunderpunch", "swordsdance"],
	},
	dianciemega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["diamondstorm", "moonblast", "earthpower", "stealthrock"],
	},
	gallademega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "knockoff", "swordsdance", "tripleaxel"],
	},
	gardevoirmega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["hypervoice", "rapidspin", "psyshock", "focusblast"],
	},
	gengar: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["shadowball", "sludgewave", "nastyplot", "focusblast"],
	},
	gyarados: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "waterfall", "earthquake", "powerwhip"],
	},
	gyaradosmega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["waterfall", "crunch", "rapidspin", "lifedew"],
	},
	hawlucha: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "acrobatics", "swordsdance", "substitute"],
	},
	heracrossmega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["armthrust", "pinmissile", "knockoff", "swordsdance"],
	},
	hoopaunbound: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["hyperspacefury", "gunkshot", "firepunch", "enchantedpunch"],
	},
	hydreigon: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "darkpulse", "trashtalk", "superpower"],
	},
	jirachi: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["ironhead", "uturn", "icepunch", "trick"],
	},
	latias: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["defog", "healingwish", "dracometeor", "psychic"],
	},
	latiasmega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "psyshock", "mysticalfire", "roost"],
	},
	latios: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "agility", "psychic", "aurasphere"],
	},
	latiosmega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "aurasphere", "icebeam", "recover"],
	},
	manaphy: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["tailglow", "surf", "psychic", "energyball"],
	},
	medichammega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["fakeout", "highjumpkick", "shadowpunch", "skyuppercut"],
	},
	melmetal: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["doubleironbash", "thunderwave", "icepunch", "armthrust"],
	},
	mew: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "psychic", "focusblast", "thunder"],
	},
	moltresgalar: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["fierywrath", "toxic", "defog", "uturn"],
	},
	pinsirmega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "quickattack", "closecombat", "doubleedge"],
	},
	sableye: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["recover", "substitute", "knockoff", "curse"],
	},
	slowbromega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "futuresight", "slackoff", "teleport"],
	},
	slowkinggalar: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["futuresight", "sludgebomb", "scald", "fireblast"],
	},
	thundurus: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["lightninglance", "uturn", "knockoff", "superpower"],
	},
	thundurustherian: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "thunderbolt", "focusblast", "hiddenpowerice"],
	},
	venusaurmega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["rashpowder", "sludgebomb", "gigadrain", "synthesis"],
	},
	xurkitree: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["hypnosis", "thunderbolt", "energyball", "tailglow"],
	},
	zapdosgalar: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderouskick", "bravebird", "crushclaw", "uturn"],
	},
	aegislash: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["shadowball", "closecombat", "ironhead", "kingsshield"],
	},
	altariamega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["roost", "dragondance", "return", "earthquake"],
	},
	amoonguss: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["gigadrain", "spore", "venoshock", "hiddenpowerfire"],
	},
	azumarill: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["bellydrum", "aquajet", "enchantedpunch", "mudspike"],
	},
	beedrillmega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["uturn", "knockoff", "mudspike", "toxicthread"],
	},
	breloom: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "spore", "machpunch", "bulletseed"],
	},
	celesteela: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["autotomize", "fireblast", "airslash", "flashcannon"],
	},
	chandelure: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["shadowball", "fireblast", "energyball", "hex"],
	},
	donphan: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "knockoff", "rapidspin", "iceshard"],
	},
	dracozolt: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["boltbeak", "fireblast", "earthquake", "dracometeor"],
	},
	dragonite: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "dualwingbeat", "firepunch", "icepunch"],
	},
	feraligatr: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "liquidation", "aggravate", "suckerpunch"],
	},
	gastrodon: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["recover", "scald", "earthpower", "toxic"],
	},
	hatterene: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["lifedew", "nuzzle", "mysticalfire", "dazzlinggleam"],
	},
	hippowdon: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["slackoff", "earthquake", "stealthrock", "stoneedge"],
	},
	infernape: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["overheat", "closecombat", "gunkshot", "uturn"],
	},
	keldeo: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "taunt", "scald", "secretsword"],
	},
	keldeoresolute: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "secretsword", "aurorabeam", "flipturn"],
	},
	krookodile: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["rapidspin", "earthquake", "knockoff", "aridabsorption"],
	},
	mamoswine: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["iceshard", "earthquake", "iciclecrash", "superpower"],
	},
	mandibuzz: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["foulplay", "roost", "defog", "uturn"],
	},
	manectricmega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "overheat", "hiddenpowerice", "voltswitch"],
	},
	mienshao: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "icepunch", "knockoff", "uturn"],
	},
	moltres: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["roost", "fireblast", "hurricane", "hiddenpowergrass"],
	},
	nidoking: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["acidicfists", "mudspike", "poisondart", "icepunch"],
	},
	nidoqueen: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["acidicfists", "mudspike", "poisondart", "firepunch"],
	},
	nihilego: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["meteorbeam", "sludgewave", "grassknot", "powergem"],
	},
	quagsire: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "earthquake", "recover", "curse"],
	},
	regieleki: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["lightninglance", "voltswitch", "rapidspin", "explosion"],
	},
	ribombee: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["stickyweb", "moonblast", "uturn", "rashpowder"],
	},
	rotomheat: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "overheat", "discharge", "painsplit"],
	},
	rotomwash: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["voltswitch", "hydropump", "defog", "willowisp"],
	},
	salamence: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "hurricane", "flamethrower", "roost"],
	},
	scizor: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "bulletpunch", "uturn", "knockoff"],
	},
	skarmory: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["bodypress", "roost", "spikes", "irondefense"],
	},
	slowking: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "futuresight", "slackoff", "teleport"],
	},
	swampert: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["flipturn", "earthquake", "toxic", "stealthrock"],
	},
	talonflame: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bravebird", "roost", "flareblitz", "uturn"],
	},
	tangrowth: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["gigadrain", "knockoff", "focusblast", "smother"],
	},
	tornadus: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "hurricane", "focusblast", "darkpulse"],
	},
	umbreon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["aggravate", "toxicthread", "teleport", "moonlight"],
	},
	urshifurapidstrike: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "surgingstrikes", "uturn", "thunderpunch"],
	},
	abomasnow: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["blizzard", "auroraveil", "leafstorm", "focusblast"],
	},
	abomasnowmega: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rototiller", "grassyglide", "avalanche", "rockslide"],
	},
	absol: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nightslash", "stoneedge", "suckerpunch", "psychocut"],
	},
	absolmega: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "knockoff", "playrough", "suckerpunch"],
	},
	aerodactyl: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "stoneedge", "dualwingbeat", "icefang"],
	},
	accelgor: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "bugbuzz", "focusblast", "sludgebomb"],
	},
	aggron: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["headsmash", "heavyslam", "earthquake", "icepunch"],
	},
	aggronmega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["reconstruct", "stealthrock", "heavyslam", "earthquake"],
	},
	alcremie: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dazzlinggleam", "mysticalfire", "rapidspin", "recover"],
	},
	alomomola: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "wish", "flipturn", "toxic"],
	},
	altaria: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["defog", "roost", "skysoiree", "flamethrower"],
	},
	ambipom: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["tailslap", "armthrust", "knockoff", "uturn"],
	},
	ampharos: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["slackoff", "discharge", "hiddenpowerice", "voltswitch"],
	},
	ampharosmega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["slackoff", "dracometeor", "focusblast", "thunderbolt"],
	},
	appletun: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["recover", "appleacid", "bodypress", "leechseed"],
	},
	araquanid: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["substitute", "liquidation", "toxicthread", "leechlife"],
	},
	arbok: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["coil", "gunkshot", "earthquake", "suckerpunch"],
	},
	arcanine: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["flareblitz", "closecombat", "extremespeed", "morningsun"],
	},
	archeops: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["stoneedge", "bravebird", "uturn", "earthquake"],
	},
	arctovish: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["fishiousrend", "iciclecrash", "freezedry", "meltingpoint"],
	},
	arctozolt: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["boltbeak", "iciclecrash", "freezedry", "lowkick"],
	},
	ariados: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stickyweb", "megahorn", "toxicthread", "suckerpunch"],
	},
	armaldo: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rapidspin", "stoneedge", "knockoff", "aridabsorption"],
	},
	aromatisse: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["moonblast", "trickroom", "thunderbolt", "nastyplot"],
	},
	articuno: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["meltingpoint", "freezedry", "hurricane", "uturn"],
	},
	articunogalar: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["hurricane", "defog", "recover", "uturn"],
	},
	audino: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lifedew", "toxic", "knockoff", "healbell"],
	},
	audinomega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "lifedew", "moonblast", "flamethrower"],
	},
	aurorus: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["ancientpower", "blizzard", "earthpower", "freezedry", "stealthrock", "thunderwave"],
	},
	avalugg: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["avalanche", "recover", "bodypress", "rapidspin"],
	},
	azelf: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "focusblast", "thunderbolt", "uturn"],
	},
	banette: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "poltergeist", "gunkshot", "superpower"],
	},
	banettemega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["shiftgear", "poltergeist", "ironhead", "superpower"],
	},
	barbaracle: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "liquidation", "icepunch", "crosschop"],
	},
	barraskewda: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["liquidation", "closecombat", "poisonjab", "flipturn"],
	},
	basculin: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["flipturn", "liquidation", "superpower", "psychicfangs"],
	},
	basculinbluestriped: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "flipturn", "icebeam", "finalgambit"],
	},
	bastiodon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["reconstruct", "rockslide", "metalburst", "stealthrock"],
	},
	beautifly: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["quiverdance", "skysoiree", "bugbuzz", "hiddenpowerground"],
	},
	beedrill: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "poisondart", "xscissor", "mudspike"],
	},
	beheeyem: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["teleport", "psychic", "thunderbolt", "signalbeam"],
	},
	bellossom: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["quiverdance", "strengthsap", "gigadrain", "moonlitwaltz"],
	},
	bewear: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["curse", "doubleedge", "drainpunch", "darkestlariat"],
	},
	bibarel: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "rapidspin", "liquidation", "return"],
	},
	bisharp: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "knockoff", "suckerpunch", "ironhead"],
	},
	blastoise: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "rapidspin", "lifedew", "flipturn"],
	},
	boltund: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderfang", "firefang", "crunch", "voltswitch"],
	},
	bouffalant: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["headcharge", "closecombat", "payback", "earthquake"],
	},
	braviary: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bravebird", "closecombat", "roost", "curse"],
	},
	bronzong: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "heavyslam", "earthquake", "toxic"],
	},
	bruxish: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["liquidation", "psychicfangs", "icefang", "flipturn"],
	},
	butterfree: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["quiverdance", "hurricane", "substitute", "sleeppowder"],
	},
	buzzwole: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "thunderpunch", "icepunch", "roost"],
	},
	cacturne: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "seedbomb", "aggravate", "suckerpunch"],
	},
	calyrex: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rototiller", "seedbomb", "zenheadbutt", "batonpass"],
	},
	camerupt: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["fireblast", "earthpower", "stealthrock", "aridabsorption"],
	},
	cameruptmega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["fireblast", "earthpower", "stealthrock", "aridabsorption"],
	},
	carbink: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["moonblast", "toxic", "stealthrock", "reconstruct"],
	},
	carnivine: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "powerwhip", "knockoff", "mudspike"],
	},
	carracosta: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "stoneedge", "aquajet", "liquidation"],
	},
	castform: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["raindance", "hydropump", "snowmanjazz", "thunder"],
	},
	celebi: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["leafstorm", "earthpower", "nastyplot", "psychic"],
	},
	centiskorch: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["firelash", "uturn", "recover", "firstimpression"],
	},
	charizard: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["roost", "fireblast", "hurricane", "defog"],
	},
	chatot: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["boomburst", "skysoiree", "heatwave", "nastyplot"],
	},
	cherrim: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["solarblade", "weatherball", "growth", "hiddenpowerground"],
	},
	chesnaught: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "synthesis", "woodhammer", "drainpunch"],
	},
	chimecho: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["healingwish", "psychic", "recover", "thunderwave"],
	},
	cinccino: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["tailslap", "bulletseed", "uturn", "rockblast"],
	},
	clawitzer: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["octazooka", "aurasphere", "technoblast", "darkpulse"],
	},
	claydol: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rapidspin", "stealthrock", "scorchingsands", "teleport"],
	},
	cloyster: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "iciclespear", "rockblast", "liquidation"],
	},
	coalossal: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "flamethrower", "rapidspin", "aridabsorption"],
	},
	cobalion: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "bodypress", "ironhead", "voltswitch"],
	},
	cofagrigus: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shadowball", "bodypress", "irondefense", "willowisp"],
	},
	comfey: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "drainingkiss", "substitute", "leechseed"],
	},
	conkeldurr: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "knockoff", "machpunch", "icepunch"],
	},
	copperajah: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["heavyslam", "powerwhip", "stoneedge", "heatcrash"],
	},
	corsola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "lifedew", "scald", "earthpower"],
	},
	corsolagalar: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "nightshade", "willowisp", "strengthsap"],
	},
	cursola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shadowball", "hydropump", "earthpower", "burningjealousy"],
	},
	crabominable: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["drainpunch", "icehammer", "earthquake", "thunderpunch"],
	},
	typenull: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["uturn", "return", "rest", "sleeptalk"],
	},
	darmanitan: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["flareblitz", "thunderpunch", "uturn", "earthquake"],
	},
	decidueye: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "leafblade", "spiritshackle", "bravebird"],
	},
	dedenne: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["voltswitch", "thunderbolt", "dazzlinggleam", "hiddenpowerice"],
	},
	delcatty: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["fakeout", "doubleedge", "suckerpunch", "thunderwave"],
	},
	delibird: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "tripleaxel", "bravebird", "drillrun"],
	},
	delphox: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "fierydance", "psyshock", "focusblast"],
	},
	deoxysdefense: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["nightshade", "cosmicpower", "taunt", "recover"],
	},
	dewgong: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["whirlpool", "lifedew", "perishsong", "protect"],
	},
	dhelmise: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rototiller", "poltergeist", "grassyglide", "rapidspin"],
	},
	diancie: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["trickroom", "diamondstorm", "moonblast", "bodypress"],
	},
	diggersby: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["uturn", "return", "earthquake", "skyuppercut"],
	},
	ditto: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["transform"],
	},
	dodrio: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "bravebird", "tripleaxel", "jumpkick"],
	},
	dragalge: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "sludgewave", "focusblast", "flipturn"],
	},
	drampa: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "hypervoice", "focusblast", "fireblast"],
	},
	drapion: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "poisonjab", "pursuit", "earthquake"],
	},
	drednaw: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "liquidation", "stoneedge", "earthquake"],
	},
	drifblim: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shadowball", "calmmind", "strengthsap", "thunderbolt"],
	},
	druddigon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dragontail", "glare", "stealthrock", "earthquake"],
	},
	dubwool: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["cottonguard", "bodypress", "rest", "rapidspin"],
	},
	dugtrio: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "stoneedge", "suckerpunch", "memento"],
	},
	dugtrioalola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "stoneedge", "suckerpunch", "ironhead"],
	},
	dunsparce: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["coil", "glare", "headbutt", "roost"],
	},
	duraludon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "flashcannon", "technoblast", "stealthrock"],
	},
	durant: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["firstimpression", "ironhead", "superpower", "mudspike"],
	},
	dusknoir: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["poltergeist", "bodypress", "strengthsap", "icepunch"],
	},
	dustox: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rashpowder", "venoshock", "roost", "moonlitwaltz"],
	},
	eelektross: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["lightninglance", "gunkshot", "uturn", "icepunch"],
	},
	eiscue: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bellydrum", "icepunch", "liquidation", "zenheadbutt"],
	},
	eldegoss: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lifedew", "sleeppowder", "gigadrain", "leechseed"],
	},
	electivire: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderpunch", "knockoff", "icepunch", "suckerpunch"],
	},
	electrode: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["electroball", "rapidspin", "technoblast", "voltswitch"],
	},
	emboar: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["flareblitz", "revenge", "earthquake", "suckerpunch"],
	},
	emolga: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["electroball", "energyball", "voltswitch", "roost"],
	},
	empoleon: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "lifedew", "flipturn", "flashcannon"],
	},
	entei: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["sacredfire", "extremespeed", "stoneedge", "flareblitz"],
	},
	escavalier: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["curse", "ironhead", "revenge", "knockoff"],
	},
	espeon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "focusblast", "meteorbeam", "shadowball"],
	},
	exeggutor: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["leafstorm", "psychic", "hiddenpowerfire", "gigadrain"],
	},
	exeggutoralola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["leafstorm", "dracometeor", "flamethrower", "trickroom"],
	},
	exploud: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["boomburst", "focusblast", "overheat", "hydropump"],
	},
	falinks: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["noretreat", "closecombat", "throatchop", "poisonjab"],
	},
	farfetchd: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bravebird", "closecombat", "uturn", "leafblade"],
	},
	farfetchdgalar: {
		tier: "RU",
		doublesTier: "DOU",
	},
	fearow: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bravebird", "drillrun", "uturn", "rapidspin"],
	},
	flapple: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["gravapple", "dragonrush", "uturn", "suckerpunch"],
	},
	flareon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["firelash", "morningsun", "teleport", "sizzlyslide"],
	},
	floatzel: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["liquidation", "flipturn", "icepunch", "lowkick"],
	},
	florges: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["moonblast", "lifedew", "hiddenpowerfire", "calmmind"],
	},
	flygon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "outrage", "stoneedge", "dragondance"],
	},
	forretress: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "rapidspin", "voltswitch", "gyroball"],
	},
	froslass: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["snowmanjazz", "spikes", "taunt", "shadowball"],
	},
	frosmoth: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["quiverdance", "bugbuzz", "meltingpoint", "snowmanjazz"],
	},
	furfrou: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["return", "thunderwave", "uturn", "suckerpunch"],
	},
	furret: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["coil", "doubleedge", "knockoff", "firepunch"],
	},
	gallade: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "closecombat", "knockoff", "rapidspin"],
	},
	galvantula: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stickyweb", "bugbuzz", "voltswitch", "thunder"],
	},
	garbodor: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["gunkshot", "mudspike", "spikes", "corrosivegas"],
	},
	gardevoir: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["trick", "psychic", "moonblast", "mysticalfire"],
	},
	gigalith: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "stoneedge", "avalanche", "earthquake"],
	},
	girafarig: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "hypervoice", "psychic", "focusblast"],
	},
	glaceon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["blizzard", "freezedry", "meltingpoint", "hiddenpowerfire"],
	},
	glalie: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["iceshard", "iciclecrash", "earthquake", "protect"],
	},
	glaliemega: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "doubleedge", "earthquake", "explosion"],
	},
	glastrier: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "avalanche", "highhorsepower", "closecombat"],
	},
	gogoat: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bulkup", "hornleech", "earthquake", "milkdrink"],
	},
	golduck: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "icebeam", "petaldance", "flipturn", "focusblast"],
	},
	golem: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "stoneedge", "earthquake", "rapidspin"],
	},
	golemalola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lightninglance", "firepunch", "earthquake", "rapidspin"],
	},
	golisopod: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["firstimpression", "spikes", "liquidation", "crushclaw"],
	},
	golurk: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["poltergeist", "closecombat", "earthquake", "trick"],
	},
	goodra: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "sludgewave", "fireblast", "lifedew"],
	},
	gorebyss: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "hydropump", "icebeam", "hiddenpowergrass"],
	},
	gothitelle: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["cosmicpower", "storedpower", "rest", "sleeptalk"],
	},
	gourgeist: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["poltergeist", "powerwhip", "shadowsneak", "synthesis"],
	},
	gourgeistsmall: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["deafeningshriek", "energyball", "focusblast", "nastyplot"],
	},
	gourgeistlarge: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["poltergeist", "powerwhip", "willowisp", "synthesis"],
	},
	gourgeistsuper: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["deafeningshriek", "energyball", "fireblast", "trickroom"],
	},
	granbull: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["smother", "thunderwave", "earthquake", "healbell"],
	},
	grapploct: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "suckerpunch", "flipturn", "acidicfists"],
	},
	greedent: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["curse", "bodyslam", "firepunch", "smother"],
	},
	grimmsnarl: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bulkup", "payback", "playrough", "suckerpunch"],
	},
	grumpig: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "focusblast", "shadowball", "trick"],
	},
	gumshoos: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["return", "uturn", "payback", "earthquake"],
	},
	guzzlord: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["partingshot", "glare", "knockoff", "earthquake"],
	},
	hariyama: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "fakeout", "icepunch", "knockoff"],
	},
	haxorus: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "scaleshot", "closecombat", "poisonjab"],
	},
	heatmor: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["curse", "firelash", "suckerpunch", "drainpunch"],
	},
	heliolisk: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "surf", "voltswitch", "hypervoice"],
	},
	heracross: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "megahorn", "closecombat", "knockoff"],
	},
	hitmonchan: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["drainpunch", "shadowpunch", "machpunch", "icepunch"],
	},
	hitmonlee: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "knockoff", "stoneedge", "poisonjab"],
	},
	hitmontop: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rapidspin", "tripleaxel", "closecombat", "payback"],
	},
	honchkrow: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["suckerpunch", "aggravate", "bravebird", "superpower"],
	},
	hoopa: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "psychic", "focusblast", "shadowball"],
	},
	houndoommega: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["darkpulse", "fireblast", "trashtalk", "nastyplot"],
	},
	houndoom: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["darkpulse", "fireblast", "trashtalk", "hiddenpowergrass"],
	},
	huntail: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["waterfall", "shellsmash", "suckerpunch", "icefang"],
	},
	hypno: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bellydrum", "zenheadbutt", "hypnosis", "drainpunch"],
	},
	illumise: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["roost", "thunderwave", "uturn", "bugbuzz"],
	},
	incineroar: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "flareblitz", "rapidspin", "partingshot"],
	},
	indeedee: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["expandingforce", "hypervoice", "mysticalfire", "trick"],
	},
	indeedeef: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["expandingforce", "dazzlinggleam", "lifedew", "calmmind"],
	},
	inteleon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "icebeam", "signalbeam", "uturn"],
	},
	jellicent: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["willowisp", "hex", "scald", "strengthsap"],
	},
	jolteon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "buzzybuzz", "aurorabeam", "spikes", "voltswitch"],
	},
	jumpluff: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["skysoiree", "uturn", "strengthsap", "sleeppowder"],
	},
	jynx: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lovelykiss", "snowmanjazz", "focusblast", "nastyplot"],
	},
	kabutops: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "liquidation", "stoneedge", "superpower"],
	},
	kangaskhan: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["fakeout", "doubleedge", "suckerpunch", "poweruppunch"],
	},
	kecleon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "mudspike", "suckerpunch", "drainpunch"],
	},
	kingdra: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "icebeam", "dracometeor", "flipturn"],
	},
	kingler: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["liquidation", "mudspike", "rockslide", "swordsdance"],
	},
	klefki: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "dazzlinggleam", "thunderwave", "foulplay"],
	},
	klinklang: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["geargrind", "shiftgear", "electroball", "substitute"],
	},
	klang: {
		tier: "NFE",
		doublesTier: "DOU",
		randomBattleMoves: ["geargrind", "rapidspin", "voltswitch", "toxic"],
	},
	komala: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["return", "curse", "suckerpunch", "firepunch"],
	},
	kricketune: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["leechlife", "stickyweb", "taunt", "brickbreak"],
	},
	lanturn: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "voltswitch", "protect", "toxic", "discharge"],
	},
	lapras: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["meltingpoint", "icebeam", "thunderbolt", "lifedew"],
	},
	leafeon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["sappyseed", "strengthsap", "teleport", "mudspike"],
	},
	leavanny: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stickyweb", "xscissor", "knockoff", "leafblade"],
	},
	ledian: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["reflect", "lightscreen", "uturn", "skysoiree"],
	},
	lickilicky: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["wish", "rapidspin", "protect", "knockoff"],
	},
	liepard: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "darkpulse", "trashtalk", "copycat"],
	},
	lilligant: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["quiverdance", "leafstorm", "hiddenpowerfire", "sleeppowder"],
	},
	linoone: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bellydrum", "extremespeed", "seedbomb", "stompingtantrum"],
	},
	lopunny: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["return", "closecombat", "switcheroo", "healingwish"],
	},
	lucario: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "closecombat", "meteormash", "extremespeed"],
	},
	ludicolo: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "petaldance", "icebeam", "flipturn"],
	},
	lumineon: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["surf", "icebeam", "hiddenpowergrass", "uturn"],
	},
	lunatone: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["meteorbeam", "psyshock", "earthpower", "rockpolish"],
	},
	luvdisc: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "icebeam", "mistyexplosion", "flipturn"],
	},
	luxray: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lightninglance", "superpower", "voltswitch", "icefang"],
	},
	lycanroc: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["accelerock", "stoneedge", "closecombat", "stealthrock"],
	},
	lycanrocdusk: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["accelerock", "stoneedge", "closecombat", "swordsdance"],
	},
	lycanrocmidnight: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bonemerang", "stoneedge", "closecombat", "swordsdance"],
	},
	machamp: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dynamicpunch", "stoneedge", "bulletpunch", "knockoff"],
	},
	magcargo: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lavaplume", "earthpower", "recover", "stealthrock"],
	},
	magmortar: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["fireblast", "focusblast", "recover", "thunderbolt"],
	},
	malamar: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "superpower", "flipturn", "psychocut"],
	},
	manectric: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "overheat", "voltswitch", "switcheroo"],
	},
	mantine: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "roost", "toxic", "defog"],
	},
	maractus: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rototiller", "grassyglide", "knockoff", "drainpunch"],
	},
	marowak: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["bonemerang", "earthquake", "knockoff", "swordsdance"],
	},
	marowakalola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bonemerang", "poltergeist", "flareblitz", "swordsdance"],
	},
	masquerain: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stickyweb", "skysoiree", "hydropump", "quiverdance"],
	},
	mawile: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "playrough", "superfang", "toxic"],
	},
	medicham: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["fakeout", "highjumpkick", "enchantedpunch", "icepunch"],
	},
	meganium: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["curse", "lifedew", "petalblizzard", "earthquake"],
	},
	meloetta: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "fierydance", "moonlitwaltz", "uturn"],
	},
	meltan: {
		tier: "RU",
		doublesTier: "DOU",
	},
	meowstic: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lightscreen", "reflect", "thunderwave", "psyshock"],
	},
	meowsticf: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "signalbeam", "thunderbolt", "nastyplot"],
	},
	mesprit: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "moonblast", "hiddenpowerfire", "nastyplot"],
	},
	metagross: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["meteormash", "icepunch", "thunderpunch", "bulletpunch"],
	},
	mightyena: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["aggravate", "suckerpunch", "irontail", "playrough"],
	},
	milotic: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "lifedew", "flipturn", "dragontail"],
	},
	miltank: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["milkdrink", "bodyslam", "curse", "bodypress"],
	},
	mimikyu: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "shadowpunch", "shadowsneak", "playrough"],
	},
	minior: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "acrobatics", "stoneedge", "earthquake"],
	},
	minun: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "batonpass", "thunderbolt", "hiddenpowerice"],
	},
	mismagius: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hex", "toxic", "moonblast", "taunt"],
	},
	morpeko: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["aurawheel", "partingshot", "protect", "seedbomb"],
	},
	mothim: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lunge", "mudspike", "uturn", "roost"],
	},
	mrmime: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["trick", "focusblast", "dazzlinggleam", "psychic"],
	},
	mrrime: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rapidspin", "focusblast", "icebeam", "psychic"],
	},
	mudsdale: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["aridabsorption", "earthquake", "avalanche", "stealthrock"],
	},
	muk: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["recover", "acidicfists", "mudspike", "curse"],
	},
	mukalola: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "recover", "acidicfists", "pursuit"],
	},
	musharna: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lifedew", "calmmind", "psyshock", "moonblast"],
	},
	necrozma: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["photongeyser", "earthquake", "xscissor", "dragondance"],
	},
	ninetales: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "fireblast", "solarbeam", "scorchingsands"],
	},
	ninetalesalola: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["auroraveil", "blizzard", "moonblast", "freezedry"],
	},
	ninjask: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "uturn", "dualwingbeat", "mudspike"],
	},
	noctowl: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "hurricane", "roost", "heatwave"],
	},
	noivern: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dracometeor", "hurricane", "uturn", "flamethrower"],
	},
	obstagoon: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["obstruct", "facade", "knockoff", "closecombat"],
	},
	octillery: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "fireblast", "icebeam", "energyball"],
	},
	omastar: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "earthpower", "hydropump", "icebeam"],
	},
	oranguru: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "psychic", "focusblast", "trickroom"],
	},
	orbeetle: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hypnosis", "stickyweb", "uturn", "bodypress"],
	},
	oricorio: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["revelationdance", "hurricane", "petaldance", "calmmind"],
	},
	oricoriopau: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["revelationdance", "hurricane", "moonlitwaltz", "calmmind"],
	},
	oricoriopompom: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["revelationdance", "hurricane", "snowmanjazz", "calmmind"],
	},
	oricoriosensu: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["revelationdance", "skysoiree", "hiddenpowerfighting", "calmmind"],
	},
	pachirisu: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["electroball", "hiddenpowerice", "grassknot", "voltswitch"],
	},
	palossand: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shoreup", "scorchingsands", "hex", "toxic"],
	},
	pangoro: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "knockoff", "acidicfists", "partingshot"],
	},
	parasect: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["spore", "leechlife", "mudspike", "synthesis"],
	},
	passimian: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "knockoff", "icepunch", "uturn"],
	},
	perrserker: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["ironhead", "closecombat", "uturn", "fakeout"],
	},
	persian: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["fakeout", "doubleedge", "crushclaw", "uturn"],
	},
	persianalola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["darkpulse", "trashtalk", "nastyplot", "thunderbolt"],
	},
	phione: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "knockoff", "uturn", "lifedew"],
	},
	pidgeot: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["doubleedge", "bravebird", "uturn", "quickattack"],
	},
	pidgeotmega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["heatwave", "hurricane", "roost", "uturn"],
	},
	pikachu: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["electroball", "petaldance", "surf", "voltswitch"],
	},
	pikachualola: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachuhoenn: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachukalos: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachuoriginal: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachupartner: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachusinnoh: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachuunova: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pikachuworld: {
		tier: "RU",
		doublesTier: "DOU",
	},
	pincurchin: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["risingvoltage", "recover", "spikes", "signalbeam"],
	},
	pinsir: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "xscissor", "closecombat", "earthquake"],
	},
	plusle: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "thunderbolt", "hiddenpowerice", "grassknot"],
	},
	politoed: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "lifedew", "icebeam", "flipturn"],
	},
	poliwrath: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["liquidation", "closecombat", "acidicfists", "flipturn"],
	},
	polteageist: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "shadowball", "gigadrain", "storedpower"],
	},
	polteageistantique: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["strengthsap", "hex", "willowisp", "curse"],
	},
	porygonz: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["technoblast", "shadowball", "icebeam", "nastyplot"],
	},
	primarina: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "moonblast", "snowmanjazz", "flipturn"],
	},
	primeape: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "aggravate", "uturn", "gunkshot"],
	},
	probopass: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "powergem", "earthpower", "aurorabeam"],
	},
	purugly: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["fakeout", "bodyslam", "knockoff", "uturn"],
	},
	pyroar: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["overheat", "hypervoice", "hiddenpowergrass", "fireblast"],
	},
	pyukumuku: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["rest", "recover", "block", "spite"],
	},
	qwilfish: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "liquidation", "poisondart", "mudspike"],
	},
	raichu: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["volttackle", "fakeout", "extremespeed", "knockoff"],
	},
	raichualola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["electroball", "psychic", "focusblast", "nastyplot"],
	},
	raikou: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "aurorabeam", "aurasphere", "voltswitch"],
	},
	rampardos: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["headsmash", "firepunch", "superpower", "zenheadbutt"],
	},
	ferroseed: {
		tier: "RU",
		doublesTier: "DOU",
	},
	rapidashgalar: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "playrough", "highhorsepower", "morningsun"],
	},
	rapidash: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "flareblitz", "highhorsepower", "wildcharge"],
	},
	raticate: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["facade", "uturn", "suckerpunch", "stompingtantrum"],
	},
	raticatealola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "knockoff", "suckerpunch", "doubleedge"],
	},
	regice: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["icebeam", "focusblast", "thunderbolt", "rockpolish"],
	},
	regidrago: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dragonenergy", "dracometeor", "dragonpulse", "explosion"],
	},
	regigigas: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["return", "earthquake", "knockoff", "reconstruct"],
	},
	regirock: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["curse", "rockblast", "bodypress", "reconstruct"],
	},
	registeel: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bodypress", "reconstruct", "heavyslam", "stealthrock"],
	},
	reuniclus: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "recover", "psyshock", "focusblast"],
	},
	rhyperior: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["aridabsorption", "rapidspin", "earthquake", "stoneedge"],
	},
	roserade: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "gigadrain", "sludgebomb", "hiddenpowerfire"],
	},
	rotom: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "thunderbolt", "shadowball", "painsplit"],
	},
	rotomfan: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "electroball", "airslash", "protect"],
	},
	rotommow: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "leafstorm", "voltswitch", "trick"],
	},
	rotomfrost: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hypervoice", "thunderbolt", "voltswitch", "nastyplot"],
	},
	runerigus: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["aridabsorption", "poltergeist", "bodypress", "willowisp"],
	},
	salazzle: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "sludgewave", "fierydance", "hiddenpowergrass"],
	},
	samurott: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "hydropump", "focusblast", "blizzard"],
	},
	sandaconda: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["aridabsorption", "earthquake", "glare", "stealthrock"],
	},
	sandslash: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["aridabsorption", "earthquake", "knockoff", "swordsdance"],
	},
	sandslashalola: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "earthquake", "tripleaxel", "ironhead"],
	},
	sawk: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "knockoff", "poisonjab", "skyuppercut"],
	},
	sawsbuck: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rototiller", "hornleech", "doubleedge", "jumpkick"],
	},
	sceptile: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "earthquake", "leafblade", "rockslide"],
	},
	sceptilemega: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["leafstorm", "dragonpulse", "focusblast", "toxic"],
	},
	scolipede: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "earthquake", "megahorn", "poisonjab"],
	},
	scrafty: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["curse", "knockoff", "drainpunch", "acidicfists"],
	},
	seaking: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "waterfall", "lightninglance", "megahorn"],
	},
	seismitoad: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "earthquake", "scald", "toxic"],
	},
	seviper: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "poisondart", "poisonjab", "knockoff", "earthquake"],
	},
	sharpedo: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["liquidation", "aggravate", "closecombat", "protect"],
	},
	sharpedomega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["icefang", "crunch", "closecombat", "protect"],
	},
	shaymin: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["seedflare", "earthpower", "substitute", "leechseed"],
	},
	shedinja: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["hex", "toxic", "curse", "protect"],
	},
	shiftry: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["leafstorm", "moonlitwaltz", "focusblast", "nastyplot"],
	},
	shiinotic: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["strengthsap", "moonblast", "spore", "gigadrain"],
	},
	shuckle: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["aridabsorption", "stealthrock", "toxicthread", "knockoff"],
	},
	sigilyph: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "heatwave", "roost", "defog", "dazzlinggleam"],
	},
	simipour: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "icebeam", "focusblast", "flipturn"],
	},
	simisage: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rototiller", "seedbomb", "superpower", "knockoff"],
	},
	simisear: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "overheat", "focusblast", "grassknot"],
	},
	sirfetchd: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["closecombat", "firstimpression", "lightninglance", "knockoff"],
	},
	skuntank: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["strengthsap", "willowisp", "knockoff", "partingshot"],
	},
	slaking: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["doubleedge", "aggravate", "earthquake", "lowkick"],
	},
	slowbrogalar: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "shellsidearm", "psychic", "focusblast"],
	},
	slurpuff: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bellydrum", "enchantedpunch", "firepunch", "thunderpunch"],
	},
	smeargle: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stickyweb", "stealthrock", "spore", "rapidspin"],
	},
	snorlax: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bodyslam", "curse", "payback", "earthquake"],
	},
	solrock: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "stoneedge", "flareblitz", "earthquake"],
	},
	spinda: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["fakeout", "doubleedge", "superpower", "suckerpunch"],
	},
	spiritomb: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["poltergeist", "suckerpunch", "pursuit", "willowisp"],
	},
	stakataka: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["trickroom", "gyroball", "stoneedge", "earthquake"],
	},
	stantler: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["doubleedge", "suckerpunch", "earthquake", "jumpkick"],
	},
	staraptor: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["bravebird", "doubleedge", "closecombat", "uturn"],
	},
	starmie: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["hydropump", "blizzard", "flipturn", "thunder"],
	},
	steelix: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["aridabsorption", "curse", "heavyslam", "earthquake"],
	},
	steelixmega: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["aridabsorption", "stealthrock", "irontail", "earthquake"],
	},
	stonjourner: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stoneedge", "heatcrash", "earthquake", "stealthrock"],
	},
	stoutland: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["return", "superpower", "playrough", "bonemerang"],
	},
	stunfisk: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["flipturn", "stealthrock", "discharge", "earthpower"],
	},
	stunfiskgalar: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["earthquake", "stealthrock", "stoneedge", "toxic"],
	},
	sudowoodo: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["headsmash", "stealthrock", "earthquake", "woodhammer"],
	},
	suicune: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "scald", "substitute", "protect"],
	},
	sunflora: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["leafstorm", "earthpower", "hiddenpowerfire", "gigadrain"],
	},
	swalot: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["acidicfists", "earthquake", "icepunch", "aggravate"],
	},
	swanna: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hurricane", "scald", "flipturn", "icebeam"],
	},
	swellow: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["boomburst", "hurricane", "heatwave", "uturn"],
	},
	swoobat: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["calmmind", "roost", "storedpower", "skysoiree"],
	},
	sylveon: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["sparklyswirl", "moonlight", "lovelykiss", "mysticalfire"],
	},
	tapubulu: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "woodhammer", "superpower", "enchantedpunch"],
	},
	tauros: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bodyslam", "aggravate", "closecombat", "ironhead"],
	},
	tentacruel: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "rapidspin", "knockoff", "sludgebomb"],
	},
	terrakion: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["accelerock", "stoneedge", "earthquake", "closecombat"],
	},
	thievul: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "darkpulse", "trashtalk", "burningjealousy"],
	},
	throh: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["circlethrow", "knockoff", "rest", "sleeptalk"],
	},
	togedemaru: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["lightninglance", "ironhead", "uturn", "fakeout"],
	},
	togekiss: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "skysoiree", "flamethrower", "roost"],
	},
	torkoal: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "lavaplume", "bodypress", "aridabsorption"],
	},
	torterra: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "woodhammer", "earthquake", "avalanche"],
	},
	toucannon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["boomburst", "heatwave", "skysoiree", "roost"],
	},
	toxicroak: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "gunkshot", "armthrust", "suckerpunch"],
	},
	toxtricity: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["boomburst", "overdrive", "shiftgear", "technoblast"],
	},
	toxtricitylowkey: {
		tier: "RU",
		doublesTier: "DOU",
	},
	trevenant: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rototiller", "poltergeist", "grassyglide", "drainpunch"],
	},
	tropius: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "roost", "earthquake", "leafblade"],
	},
	tsareena: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["tropkick", "rapidspin", "knockoff", "uturn", "tripleaxel"],
	},
	turtonator: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "overheat", "dracometeor", "scorchingsands"],
	},
	typhlosion: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["eruption", "fireblast", "earthpower", "meteorbeam"],
	},
	tyrantrum: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "headsmash", "earthquake", "scaleshot"],
	},
	unfezant: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["uturn", "quickattack", "aggravate", "bravebird"],
	},
	unown: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["hiddenpowerpsychic"],
	},
	ursaring: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["facade", "closecombat", "payback", "swordsdance"],
	},
	uxie: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "teleport", "doomdesire", "taunt"],
	},
	vanilluxe: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["blizzard", "hiddenpowerfire", "freezedry", "meltingpoint"],
	},
	vaporeon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "teleport", "lifedew", "toxic"],
	},
	venomoth: {
		tier: "RUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["quiverdance", "sleeppowder", "bugbuzz", "sludgebomb"],
	},
	venusaur: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["sunnyday", "weatherball", "solarbeam", "earthpower"],
	},
	vespiquen: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["attackorder", "toxicthread", "healorder", "signalbeam"],
	},
	victreebel: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "powerwhip", "poisonjab", "mudspike"],
	},
	vikavolt: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["agility", "thunderbolt", "bugbuzz", "energyball"],
	},
	vileplume: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rashpowder", "strengthsap", "sludgebomb", "gigadrain"],
	},
	virizion: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["sleeppowder", "swordsdance", "powerwhip", "closecombat"],
	},
	vivillon: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["quiverdance", "hurricane", "sleeppowder", "substitute"],
	},
	volbeat: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["tailglow", "batonpass", "bugbuzz", "thunderbolt"],
	},
	volcanion: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["steameruption", "fireblast", "earthpower", "aridabsorption"],
	},
	wailord: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["liquidation", "lifedew", "curse", "earthquake"],
	},
	vivillonfancy: {
		tier: "RU",
		doublesTier: "DOU",
	},
	vivillonpokeball: {
		tier: "RU",
		doublesTier: "DOU",
	},
	walrein: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["meltingpoint", "toxic", "superfang", "protect"],
	},
	watchog: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["focusblast", "shadowball", "nastyplot", "thunder"],
	},
	weezing: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["trashtalk", "flamethrower", "willowisp", "painsplit"],
	},
	weezinggalar: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["strangesteam", "willowisp", "sludgebomb", "defog"],
	},
	whimsicott: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rashpowder", "uturn", "moonblast", "energyball"],
	},
	whiscash: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dragondance", "liquidation", "earthquake", "stoneedge"],
	},
	wigglytuff: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["geomancy", "dazzlinggleam", "focusblast", "thunderbolt"],
	},
	wishiwashi: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["scald", "coreenforcer", "recover", "uturn"],
	},
	wormadam: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["quiverdance", "gigadrain", "earthpower", "thunderbolt"],
	},
	wormadamsandy: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["spikes", "recover", "earthquake", "uturn"],
	},
	wormadamtrash: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["rapidspin", "flashcannon", "uturn", "stealthrock"],
	},
	xatu: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["psychic", "roost", "teleport", "heatwave"],
	},
	yanmega: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["bugbuzz", "airslash", "gigadrain", "uturn"],
	},
	zangoose: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["facade", "quickattack", "knockoff", "closecombat"],
	},
	zarude: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["bulkup", "powerwhip", "aggravate", "junglehealing"],
	},
	zarudedada: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["powerwhip", "aggravate", "uturn", "closecombat"],
	},
	zeraora: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["electroball", "closecombat", "hiddenpowerice", "voltswitch"],
	},
	zoroark: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["nastyplot", "trashtalk", "moonlitwaltz", "flamethrower"],
	},
	zygarde10: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["thousandarrows", "toxic", "extremespeed", "outrage"],
	},
	porygon2: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["icebeam", "foulplay", "recover", "thunderwave"],
	},
	crawdaunt: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "knockoff", "crabhammer", "aquajet"],
	},
	cresselia: {
		tier: "OU",
		doublesTier: "DOU",
		randomBattleMoves: ["moonblast", "psyshock", "moonlight", "calmmind"],
	},
	doublade: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "shadowclaw", "shadowsneak", "closecombat"],
	},
	magneton: {
		tier: "UU",
		doublesTier: "DOU",
		randomBattleMoves: ["thunderbolt", "flashcannon", "hiddenpowerfire", "voltswitch"],
	},
	scyther: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["dualwingbeat", "uturn", "swordsdance", "knockoff"],
	},
	beartic: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["swordsdance", "icepunch", "thunderpunch", "superpower"],
	},
	cradily: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["stealthrock", "recover", "gigadrain", "toxic"],
	},
	cramorant: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["surf", "attackorder", "roost", "endure"],
	},
	crustle: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["shellsmash", "stoneedge", "earthquake", "spikes"],
	},
	cryogonal: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["icebeam", "meltingpoint", "recover", "defog"],
	},
	lurantis: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["leafstorm", "superpower", "defog", "synthesis"],
	},
	relicanth: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["curse", "liquidation", "headsmash", "earthquake"],
	},
	wobbuffet: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["counter", "mirrorcoat", "encore", "destinybond"],
	},
	sandshrewalola: {
		tier: "LC",
		doublesTier: "DOU",
	},
	zebstrika: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["lightninglance", "hiddenpowerice", "overheat", "voltswitch"],
	},
	clamperl: {
		tier: "LC",
		doublesTier: "DOU",
	},
	sableyemega: {
		tier: "UUBL",
		doublesTier: "DOU",
		randomBattleMoves: ["recover", "knockoff", "willowisp", "taunt"],
	},
	sneasel: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["knockoff", "tripleaxel", "iceshard", "pursuit"],
	},
	crobat: {
		tier: "RU",
		doublesTier: "DOU",
		randomBattleMoves: ["crosspoison", "curse", "bravebird", "aggravate"],
	},
};
